import { companyFuelSurcharge } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getCompanyFuelSurchargeList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(companyFuelSurcharge.companyFuelSurchargeBase, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  addCompanyFuelSurcharge(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(companyFuelSurcharge.companyFuelSurchargeBase, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCompanyFuelSurchargeObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${companyFuelSurcharge.companyFuelSurchargeBase}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateCompanyFuelSurcharge(payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${companyFuelSurcharge.companyFuelSurchargeBase}${payload.id}/`, payload.data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  partiallyUpdateCompanyFuelSurcharge(payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${companyFuelSurcharge.companyFuelSurchargeBase}${payload.id}/`, payload.data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
